module.exports = __webpack_public_path__ + "static/media/footer1.2860d1fa.png";